import React from 'react';
/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').BrochureImageBlock}
 */
const BrochureImageBlock = ({
    brochureImage
}) => {
    return (
        <figure className='height-100 width-100'>
            <img
                className='height-100 width-100 object-cover'
                src={brochureImage.src} />
        </figure>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default BrochureImageBlock;
